import $ from 'jquery';
import axios from "axios";
import {COOKIE_AGREEMENT, getCookie, setCookie} from "Core/helpers/cookieHelper";
import {MODAL_INFO_COOKIE} from "Core/links";

export const cookieModalInfoHandlers = () => {
    if (window.localStorage.getItem(COOKIE_AGREEMENT) !== null) {
        $('#cookie-modal.modal-info').remove();

        let cookies = getCookie(COOKIE_AGREEMENT);

        if (cookies === undefined) {
            setCookie(COOKIE_AGREEMENT, true, {secure: true, 'max-age': 36000000});
        }
    } else {
        axios.get(MODAL_INFO_COOKIE)
            .then((response) => {
                $('#modal-info-block').html(response.data);

                $('#cookieModalInfo').click(function () {
                    cookieModalInfoHandler($(this));
                });
            });
    }
};

const cookieModalInfoHandler = (element) => {
    axios.post(element.data('url'), {})
        .then((response) => {
            window.localStorage.setItem(COOKIE_AGREEMENT, true);
            $('#cookie-modal').remove();
        });
};
